import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function About() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    document.title = 'Sydney Ferris - Home';
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="font-girott text-4xl"
      style={{
        height: 'calc(100vh - 4rem)',
        backgroundImage: 'url("/assets/grand-canyon.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'scroll',
        overflow: 'hidden'
      }}
    >

      <div className="bg-black bg-opacity-50 h-full p-4 sm:p-6 md:p-8 relative">
        {/* Desktop: Right aligned, Mobile: Centered */}
        <div className="hidden md:flex flex-col items-end justify-start absolute top-1/4 right-[7%] space-y-4">
          <h1
            className="hero-title"
            style={{
              color: 'rgb(186 183 174)',
              opacity: showContent ? 1 : 0,
              transform: `translateY(${showContent ? '0px' : '-20px'})`,
              transition: 'opacity 1s ease-in-out, transform 1s ease-in-out',
              fontSize: 'clamp(3rem, 12vw, 10rem)',
              lineHeight: 'clamp(3rem, 12vw, 10rem)'
            }}
          >
            Sydney Ferris
          </h1>
          
          <Link
              to="/resume"
              className="theme-bg-primary theme-primary px-6 py-3 rounded-lg font-semibold"
              style={{
                opacity: showContent ? 1 : 0,
                transform: `translateY(${showContent ? '0px' : '20px'})`,
                transition: 'opacity 1s ease-in-out 0.5s, transform 1s ease-in-out 0.5s',
                fontSize: 'clamp(1rem, 3vw, 1.5rem)'
              }}
            >
              Find out where I've been
            </Link>
        </div>

        {/* Mobile: Centered */}
        <div className="md:hidden flex flex-col items-center justify-center h-full space-y-8">
          <h1
            className="hero-title"
            style={{
              color: 'rgb(186 183 174)',
              opacity: showContent ? 1 : 0,
              transform: `translateY(${showContent ? '0px' : '-20px'})`,
              transition: 'opacity 1s ease-in-out, transform 1s ease-in-out',
              fontSize: 'clamp(3rem, 15vw, 8rem)',
              lineHeight: 'clamp(3rem, 15vw, 8rem)',
              textAlign: 'center'
            }}
          >
            Sydney Ferris
          </h1>
          
          <Link
              to="/resume"
              className="theme-bg-primary theme-primary px-4 py-2 rounded-lg font-semibold"
              style={{
                opacity: showContent ? 1 : 0,
                transform: `translateY(${showContent ? '0px' : '20px'})`,
                transition: 'opacity 1s ease-in-out 0.5s, transform 1s ease-in-out 0.5s',
                fontSize: 'clamp(0.875rem, 4vw, 1.25rem)',
                textAlign: 'center'
              }}
            >
              Find out where I've been
            </Link>
        </div>
      </div>

    </div>
  );
}

export default About;
